module.exports = __webpack_public_path__ + "img/local-9.3ebca0f5.jpg";